import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/waiverSetting`;

export const ROUTE: RouteDefinition = `${baseRoute}/waiverSetting`;

export const URL = (): RouteDefinition => `${baseRoute}/waiverSetting`;
